// Sort search results: on-sale products (.price--on-sale) float to top
function sortResultsBySale(grid) {
  if (!grid) return;
  var blocks = Array.from(grid.querySelectorAll('.product-block'));
  if (blocks.length < 2) return;
  var onSale = [], regular = [];
  blocks.forEach(function(b) {
    (b.querySelector('.price--on-sale') ? onSale : regular).push(b);
  });
  onSale.concat(regular).forEach(function(b) { grid.appendChild(b); });
}

const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    // Helper: reset all search state so empty-state panel shows correctly on next open
    const resetSearch = () => {
      this.classList.remove(
        'main-search--has-results', 'main-search--results-on-multiple-lines',
        'main-search--loading', 'main-search--no-results'
      );
      const rb = this.querySelector('.main-search__results');
      if (rb) rb.innerHTML = '';
      const va = this.querySelector('.hewyn-view-all');
      if (va) va.innerHTML = '';
    };

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
        resetSearch();
      });
    });

    // Pressing escape key
    this.querySelector('.main-search__input').addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close').dispatchEvent(new Event('click'));
      }
    });

    // Clicking outside search (on page-shade) closes search
    const pageShade = document.querySelector('.page-shade');
    if (pageShade) {
      pageShade.addEventListener('click', (evt) => {
        if (document.body.classList.contains('show-search')) {
          evt.preventDefault();
          document.body.classList.remove('show-search');
          resetSearch();
        }
      });
    }

    // Search as you type
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 500;
    const resultLimit = 10;
    const includeMeta = this.dataset.quickSearchMeta === 'true';
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      const valueToSearch = searchInput.value;

      // Only search if search string longer than 2, and it has changed
      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        // Save previous value
        this.oldSearchValue = valueToSearch;

        // Kill outstanding ajax request
        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }

        // Kill previous search
        clearTimeout(searchTimeoutID);

        // Create URL for full search results
        const form = searchInput.closest('form');
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => { linkURL.searchParams.set(key, value); });

        // Show loading
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        this.classList.add('main-search--loading');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl;

          // Predictive search hardcoded to /search/suggest (root, no locale prefix).
          // Shopify's predictive-search API returns 417 "Unsupported buyer locale"
          // for /ar-ae/, /en-ae/, and other market-locale endpoints. The root endpoint
          // works and the response section still renders localized product data since
          // it's server-rendered via the theme's current section context.
          ajaxUrl = new URL('/search/suggest', window.location.origin);
          ajaxUrl.searchParams.set('q', valueToSearch);
          ajaxUrl.searchParams.set('section_id', 'predictive-search');
          // NOTE: resources[type] / resources[limit] / resources[options][fields]
          // were removed — Shopify's /search/suggest returns HTTP 422
          // "Invalid parameter error: expected String to be a Hash: resources"
          // when those are present. The section renders default resources fine.

          fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const template = document.createElement('template');
              template.innerHTML = response;
              // Always query .product-grid — both predictive-search and main-search sections use it
              const resultsList = template.content.querySelector('.product-grid');

              // Guard: if section returned no product grid, show empty state
              if (!resultsList) {
                this.classList.remove('main-search--loading');
                this.classList.add('main-search--no-results');
                return;
              }

              // reset previous contents
              searchAbortController = null;
              this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
              resultsBox.innerHTML = '';

              const resultsProducts = document.createElement('div');
              resultsProducts.className = 'main-search__results__products collection-listing';
              resultsProducts.innerHTML = '<div></div>';
              const resultsPages = document.createElement('div');
              resultsPages.className = 'main-search__results__pages';

              resultsProducts.firstElementChild.className = resultsList.className;

              // Convert standard blocks into quick search result format
              resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)').forEach((block, index) => {
                if (index <= resultLimit) {
                  block.classList.add('main-search-result');
                  block.querySelectorAll('.btn.quickbuy-toggle').forEach((el) => el.remove());
                  block.querySelectorAll('.quickbuy-toggle').forEach((el) => el.classList.remove('quickbuy-toggle'));
                  resultsProducts.firstElementChild.appendChild(block);
                }
              });

              resultsList.querySelectorAll('.product-block.page-block').forEach((block) => {
                const item = document.createElement('a');
                item.className = 'main-search-result main-search-result--page';
                item.href = block.querySelector('a').href;
                item.innerHTML = '<div class="main-search-result__text"></div>';
                item.firstElementChild.innerText = block.querySelector('.page-block__title').innerText;
                resultsPages.appendChild(item);
              });

              this.classList.remove('main-search--loading');

              const areProducts = !!resultsProducts.querySelector('.main-search-result');
              const arePages = !!resultsPages.querySelector('.main-search-result');
              if (areProducts || arePages) {
                // Numerous results
                this.classList.add('main-search--has-results');
                this.classList.toggle('main-search--results-on-multiple-lines', resultsProducts.querySelectorAll('.product-block').length > 4);
                if (areProducts) {
                  sortResultsBySale(resultsProducts.firstElementChild);
              // Fix white title color from main.css dark-theme rule
              resultsProducts.querySelectorAll('.product-block__title a').forEach(function(a) {
                a.style.cssText = 'color:#1a3a3a!important;font-size:13px!important;font-weight:600!important;';
              });
              resultsProducts.querySelectorAll('.product-block').forEach(function(b) {
                b.style.cssText = 'background:#f8f8f6!important;text-align:left!important;';
              });
              resultsProducts.querySelectorAll('.vendor').forEach(function(v) {
                v.style.cssText = 'color:#888!important;font-size:10px!important;text-transform:uppercase!important;letter-spacing:0.06em!important;';
              });
                  resultsBox.appendChild(resultsProducts);
                }
                if (arePages) {
                  const heading = document.createElement('h6');
                  heading.className = 'main-search-result__heading';
                  heading.innerHTML = theme.strings.generalSearchPages;
                  resultsPages.insertAdjacentElement('afterbegin', heading);
                  resultsBox.appendChild(resultsPages);
                }

                // Populate the hewyn-view-all sticky button
                const viewAllDiv = this.querySelector('.hewyn-view-all');
                if (viewAllDiv) {
                  viewAllDiv.innerHTML = '';
                  const allLink = document.createElement('a');
                  allLink.className = 'hewyn-view-all-link';
                  allLink.href = linkURL;
                  allLink.textContent = 'View all';
                  viewAllDiv.appendChild(allLink);
                }
              } else {
                // No results - show nothing
                this.classList.add('main-search--no-results');
                const emptyMessage = document.createElement('div');
                emptyMessage.className = 'main-search__empty-message';
                emptyMessage.innerHTML = theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            })
            .catch((error) => {
              console.warn(error);
            });
        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        // Abandon current search
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        // Clear results
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading');
        resultsBox.innerHTML = '';
        const oldViewAll = this.querySelector('.hewyn-view-all');
        if (oldViewAll) oldViewAll.innerHTML = '';
      }
    };

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));

    // Hide "View all" button when the trailing footer (trending section) scrolls into view
    const scrollArea = this.querySelector('.hewyn-scroll-area');
    const footerEl   = this.querySelector('.hewyn-search-footer');
    const viewAllEl  = this.querySelector('.hewyn-view-all');
    if (scrollArea && footerEl && viewAllEl) {
      const io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          // entry.isIntersecting = footer is visible inside the scroll area
          if (entry.isIntersecting) {
            viewAllEl.style.opacity = '0';
            viewAllEl.style.pointerEvents = 'none';
          } else {
            viewAllEl.style.opacity = '';
            viewAllEl.style.pointerEvents = '';
          }
        });
      }, { root: scrollArea, threshold: 0.1 });
      io.observe(footerEl);
    }
  }
};

window.customElements.define('main-search', MainSearch);
